import { service } from '../../../../helpers/http' 

export const ActionStoreSendChatbotFeedback = ({ dispatch }, payload) => { 
    return service({
        module: 'chatBot',
        action: 'storeSendChatbotFeedback',
        payload: payload
    })
}

export const ActionPutChatbotFeedbacks = ({ dispatch }, payload) => { 
    return service({
        module: 'chatBot',
        action: 'putChatbotFeedback',
        payload: payload
    })
}

export const ActionGetChatbotFeedbacks = ({ dispatch }, payload) => { 
    return service({
        module: 'chatBot',
        action: 'getChatbotFeedback',
        payload: payload
    })
}